import { datadogRum } from '@datadog/browser-rum';
import { EyeIcon } from '@heroicons/react/24/outline';
import { Icon } from '@stereograph/teia-system-design/components/Icon';
import { IconButton } from '@stereograph/teia-system-design/components/IconButton';
import { Tooltip } from '@stereograph/teia-system-design/components/Tooltip';
import { usePluginTranslation } from '@translation';
import { useState } from 'react';
import { AnomalyDocumentVisualizationModal } from './AnomalyDocumentVisualizationModal';

export const AnomalyCardVisualizeDocument = () => {
  const [isVisualizing, setIsVisualizing] = useState(false);
  const { t } = usePluginTranslation();

  const onOpenVisualizeDocumentModal = () => {
    setIsVisualizing(true);
    datadogRum.addAction('tvp.anomaly.document.visualize_document_modal', {
      isOpen: true,
    });
  };

  const onCloseVisualizeDocumentModal = () => {
    setIsVisualizing(false);
    datadogRum.addAction('tvp.anomaly.document.visualize_document_modal', {
      isOpen: false,
    });
  };

  return (
    <>
      <Tooltip
        title={t('anomaly_plugin.widget.visualize.button.label')}
      >
        <IconButton
          aria-label={t('anomaly_plugin.widget.visualize.button.label')}
          onClick={onOpenVisualizeDocumentModal}
          iconOnly
        >
          <Icon component={EyeIcon} />
        </IconButton>
      </Tooltip>
      {!!isVisualizing && (
        <AnomalyDocumentVisualizationModal
          isModalOpen={isVisualizing}
          onClose={onCloseVisualizeDocumentModal}
        />
      )}
    </>
  );
};

